package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StarShineW500Rounded: ImageVector
    get() {
        if (_starShineW500Rounded != null) {
            return _starShineW500Rounded!!
        }
        _starShineW500Rounded = Builder(name = "StarShineW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(795.67f, 577.72f)
                quadToRelative(18.66f, 0.0f, 32.33f, 13.67f)
                lineToRelative(60.61f, 61.37f)
                quadToRelative(13.67f, 13.67f, 13.67f, 31.95f)
                quadToRelative(0.0f, 18.27f, -13.67f, 31.94f)
                quadToRelative(-13.68f, 13.68f, -31.95f, 13.68f)
                reflectiveQuadToRelative(-31.94f, -13.68f)
                lineToRelative(-61.37f, -60.61f)
                quadToRelative(-13.68f, -13.67f, -13.68f, -32.32f)
                reflectiveQuadToRelative(13.68f, -32.33f)
                quadToRelative(13.67f, -13.67f, 32.32f, -13.67f)
                close()
                moveTo(817.5f, 148.02f)
                quadToRelative(0.0f, 18.65f, -13.67f, 32.33f)
                lineToRelative(-60.61f, 60.61f)
                quadToRelative(-13.68f, 13.67f, -32.33f, 13.67f)
                reflectiveQuadToRelative(-32.32f, -13.67f)
                quadToRelative(-13.68f, -13.68f, -13.68f, -32.33f)
                reflectiveQuadToRelative(13.68f, -32.33f)
                lineToRelative(61.36f, -60.6f)
                quadToRelative(13.68f, -13.68f, 31.95f, -13.68f)
                reflectiveQuadToRelative(31.95f, 13.68f)
                quadToRelative(13.67f, 13.67f, 13.67f, 32.32f)
                close()
                moveTo(188.5f, 102.02f)
                quadToRelative(18.65f, 0.0f, 32.33f, 13.68f)
                lineToRelative(60.6f, 61.37f)
                quadToRelative(13.68f, 13.67f, 13.68f, 31.94f)
                quadToRelative(0.0f, 18.27f, -13.68f, 31.95f)
                quadToRelative(-13.67f, 13.67f, -32.32f, 13.67f)
                reflectiveQuadToRelative(-32.33f, -13.67f)
                lineToRelative(-60.61f, -60.61f)
                quadToRelative(-13.67f, -13.68f, -13.67f, -32.33f)
                reflectiveQuadToRelative(13.67f, -32.32f)
                quadToRelative(13.68f, -13.68f, 32.33f, -13.68f)
                close()
                moveTo(210.57f, 623.72f)
                quadToRelative(0.0f, 18.65f, -13.68f, 32.32f)
                lineToRelative(-60.61f, 60.61f)
                quadToRelative(-13.67f, 13.68f, -32.32f, 13.68f)
                quadToRelative(-18.66f, 0.0f, -32.33f, -13.68f)
                quadToRelative(-13.67f, -13.67f, -13.67f, -32.32f)
                quadToRelative(0.0f, -18.66f, 13.67f, -32.33f)
                lineTo(133.0f, 591.39f)
                quadToRelative(13.67f, -13.67f, 31.95f, -13.67f)
                quadToRelative(18.27f, 0.0f, 31.94f, 13.67f)
                quadToRelative(13.68f, 13.68f, 13.68f, 32.33f)
                close()
                moveTo(365.96f, 657.7f)
                lineTo(480.0f, 588.63f)
                lineToRelative(114.28f, 70.07f)
                lineToRelative(-29.89f, -130.37f)
                lineToRelative(101.2f, -87.63f)
                lineToRelative(-132.85f, -11.81f)
                lineTo(480.0f, 305.33f)
                lineToRelative(-52.74f, 122.8f)
                lineToRelative(-132.61f, 11.8f)
                lineToRelative(101.2f, 88.4f)
                lineToRelative(-29.89f, 129.37f)
                close()
                moveTo(480.0f, 481.63f)
                close()
                moveTo(480.0f, 695.54f)
                lineTo(320.46f, 791.96f)
                quadToRelative(-12.68f, 7.95f, -26.35f, 6.83f)
                quadToRelative(-13.68f, -1.12f, -23.87f, -9.07f)
                quadToRelative(-10.2f, -7.96f, -15.79f, -20.01f)
                quadToRelative(-5.6f, -12.06f, -2.12f, -26.73f)
                lineToRelative(42.32f, -181.83f)
                lineToRelative(-141.74f, -122.69f)
                quadToRelative(-11.43f, -10.2f, -14.29f, -23.25f)
                quadToRelative(-2.86f, -13.06f, 1.38f, -25.49f)
                quadToRelative(4.24f, -12.44f, 13.79f, -20.63f)
                quadToRelative(9.56f, -8.2f, 25.23f, -10.2f)
                lineToRelative(186.59f, -16.28f)
                lineToRelative(72.37f, -171.78f)
                quadToRelative(5.72f, -13.92f, 17.53f, -20.63f)
                quadToRelative(11.82f, -6.72f, 24.49f, -6.72f)
                quadToRelative(12.67f, 0.0f, 24.49f, 6.72f)
                quadToRelative(11.81f, 6.71f, 17.53f, 20.63f)
                lineToRelative(72.37f, 171.78f)
                lineToRelative(186.83f, 16.28f)
                quadToRelative(15.67f, 2.0f, 25.11f, 10.2f)
                quadToRelative(9.43f, 8.19f, 13.67f, 20.63f)
                quadToRelative(4.24f, 12.43f, 1.5f, 25.49f)
                quadToRelative(-2.74f, 13.05f, -14.17f, 23.25f)
                lineTo(665.59f, 561.15f)
                lineToRelative(42.32f, 182.07f)
                quadToRelative(3.48f, 14.67f, -2.12f, 26.73f)
                quadTo(700.2f, 782.0f, 690.0f, 789.96f)
                quadToRelative(-10.2f, 7.95f, -23.87f, 9.07f)
                quadToRelative(-13.67f, 1.12f, -26.35f, -6.83f)
                lineTo(480.0f, 695.54f)
                close()
            }
        }
        .build()
        return _starShineW500Rounded!!
    }

private var _starShineW500Rounded: ImageVector? = null
